import OpenAPIAdGroupClient from 'service/openapi-client/adGroup'
/* Return the existing client instance or instantiate the client and
 * assign it to be the existing instance.
 */
export const getAdGroupClient = async () => {
  return new OpenAPIAdGroupClient()
}
